"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _authentication_alias = _interopRequireDefault(require("authentication_alias"));

/**
 * route - when checkAuthentication is enabled it will check AuthenticationHelper.isAuthenticated
 *
 * @class Route
 * @extends {ReactRouterRoute}
 */
var Route =
/*#__PURE__*/
function (_ReactRouterRoute) {
  (0, _inherits2["default"])(Route, _ReactRouterRoute);

  function Route() {
    (0, _classCallCheck2["default"])(this, Route);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Route).apply(this, arguments));
  }

  (0, _createClass2["default"])(Route, [{
    key: "render",
    value: function render() {
      if (!this.props.checkAuthentication || this.props.checkAuthentication && _authentication_alias["default"].isAuthenticated) {
        return _react["default"].createElement(_reactRouterDom.Route, this.props);
      } else {
        var redirectUrl = _authentication_alias["default"].getLoginRedirectUrl();

        window.location.href = redirectUrl;
        return null;
      }
    }
  }]);
  return Route;
}(_reactRouterDom.Route);

Route.propTypes = {
  checkAuthentication: _propTypes["default"].bool.isRequired
};
var _default = Route;
exports["default"] = _default;